import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/bar-chart-v2.0.0'

export default  reactNode(
	'BarChart',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: false, docs: '' }
)
